export const CHART_COLORS = [
	'#183D57',
	'#F0D035',
	'#569FD3',
	'#307731',
	'#3F4B4B',
	'#1E503E',
	'#001537',
	'#DDEDE9',
	'#819391',
	'#9A2C56',
	'#9BD7F1',
	'#DF6721',
	'#52A5CF',
	'#8B6914',];

export const MAIN_PANEL_OFFSET = {
	top: 75,
	left: 88,
	right: 235,
	bottom: 50,
};